import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ContentLayout } from './styles';
import { getPositionSuggestion } from '../../helpers/positionHelper';

const TooltipBase = React.forwardRef(
  (
    {
      show,
      hoverRef,
      dataPanel,
      isSecundary,
      containerLeft,
      arrowRight,
      fixedPosition,
      startupAnimation,
      backgroundColor,
      withArrow = false,
      type = 'informative',
      children = '',
      position = null
    },
    ref
  ) => {
    const [tooltipWidth, setTooltipWidth] = useState(0);
    const [tooltipHeight, setTooltipHeight] = useState(0);
    const [tooltipPosition, setTooltipPosition] = useState('top');
    const [hoverRect] = useState(hoverRef.current.getBoundingClientRect());

    const getElementPosition = () => {
      const elementRect = ref.current.getBoundingClientRect();
      setTooltipWidth(elementRect.width);
      setTooltipHeight(elementRect.height);
      if (position) return setTooltipPosition(position);
      const suggestedPosition = getPositionSuggestion(hoverRect, elementRect);
      return setTooltipPosition(suggestedPosition);
    };

    useEffect(() => {
      if (ref.current) getElementPosition();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setPosition = isSecundary ? fixedPosition : tooltipPosition;

    return (
      <ContentLayout
        show={show}
        className={`${setPosition}`}
        tooltipWidth={tooltipWidth}
        tooltipHeight={tooltipHeight}
        hoverRect={hoverRect}
        isSecundary={isSecundary}
        containerLeft={containerLeft}
        arrowRight={arrowRight}
        startupAnimation={startupAnimation}
        backgroundColor={backgroundColor}
      >
        {withArrow && <div className={`tooltip-arrow ${setPosition}-arrow`} />}
        <div ref={ref} className={`label ${type}`} data-panel={dataPanel}>
          {children}
        </div>
      </ContentLayout>
    );
  }
);

TooltipBase.propTypes = {
  show: PropTypes.bool.isRequired
};

export default TooltipBase;
